import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import TopBar from '../components/TopBar';
import Api from '../utils/Api';
import RatingsHistory from '../components/RatingsHistoryChartComponent';
import AverageHistory from '../components/AvgBarChartComponent';
import RatingsTable from '../components/RatingsTable';
import LoadingSpinner from '../components/LoadingSpinner';
import ErrorAlert from '../components/ErrorAlert';
import * as colors from '../utils/Theme';
import config from '../config.json';
import $ from 'jquery';

import googleLogo from '../assets/google.png';

import '../style/MetricsEtablissement.css';

// MetricsEtablissement Component
class MetricsEtablissement extends Component {
    constructor() {
        super();
        this.state = {
          endDate: moment(),
          startDate: moment().subtract(30, 'days'),
          ratingsHistory: null,
          averageHistory: null,
          avg3: null,
          metrics: null,
          ratings: null,
          place: null,
          labels: [],
        };
        this.refresh = this.refresh.bind(this);
        this.userRefresh = this.userRefresh.bind(this);
    }

    userRefresh() {
        this.setState({
        ratingsHistory: null,
        averageHistory: null,
        avg3: null,
        ratings: null,
        });
        this.refresh();
    }

    refresh() {
        Api.getInfos(this.props.match.params.hash).then(
        res => {
            if (res) {
            this.setState({
                place: res,
                placeError: null,
                labels: res.labels
            });
            }
        }
        ).catch(err => {
            if (err.status === 403 || err.status === 401) {
                this.setState({ logout: true });
            }
            if (err.response && err.response.statusText)
                this.setState({ placeError: err.response.statusText });
            }
        );


        Api.getRatingsHistory(this.props.match.params.hash, this.state.startDate.format('YMMDD'), this.state.endDate.format('YMMDD')).then(
        res => {
            this.setState({ ratingsHistory: res, ratingsHistoryError: null });
        }
        ).catch(err => {
            if (err.status === 403 || err.status === 401) {
                this.setState({ logout: true });
            }
            if (err.response && err.response.statusText)
            this.setState({ ratingsHistoryError: err.response.statusText });
        });

        Api.getAverageHistory(this.props.match.params.hash, this.state.startDate.format('YMMDD'), this.state.endDate.format('YMMDD')).then(
        res => {
            this.setState({ averageHistory: res, averageHistoryError: null });
        }
        ).catch(err => {
        if (err.response && err.response.statusText)
            this.setState({ averageHistoryError: err.response.statusText });
        });

        Api.getAvg3(this.props.match.params.hash).then(
        res => {
            this.setState({ avg3: res, avg3Error: null });
        }
        ).catch(err => {
        if (err.response && err.response.statusText)
            this.setState({ avg3Error: err.response.statusText });
        });

        Api.getRatings(this.props.match.params.hash).then(
        res => {
            this.setState({ ratings: res, ratingsError: null });
        }
        ).catch(err => {
        if (err.response && err.response.statusText)
            this.setState({ ratingsError: err.response.statusText });
        });

        Api.getMetricsFirstLast(this.props.match.params.hash).then(
        res => {
            this.setState({ metrics: res, metricsError: null });
        }
        ).catch(err => {
        if (err.response && err.response.statusText)
            this.setState({ metricsError: err.response.statusText });
        });
    
    }

    componentDidMount() {
        $(function () {
         $('[data-toggle="tooltip"]').tooltip()
        })      
        this.refresh();
    }

    render() {
        if (this.state.logout)
            return <Redirect to="/login" />



        const averageBlock = this.state.avg3 && (
            <div className="row">
                <div className="col-md-6 col-lg-3">
                    <div className="card card-average">
                        <div className="title">
                            {this.state.labels ? this.state.labels[0] : ''}
                        </div>
                        <div className="value">
                            <span className="text-gradient-green-blue">{this.state.avg3 && this.state.avg3.avg1 && this.state.avg3.avg1.toFixed(1)}</span>
                            <span className="value-total">/5</span>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-3">
                    <div className="card card-average">
                        <div className="title">
                            {this.state.labels ? this.state.labels[1] : ''}
                        </div>
                        <div className="value">
                            <span className="text-gradient-purple">{this.state.avg3 && this.state.avg3.avg2 && this.state.avg3.avg2.toFixed(1)}</span>
                            <span className="value-total">/5</span>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-3">
                    <div className="card card-average">
                        <div className="title">
                            {this.state.labels ? this.state.labels[2] : ''}
                        </div>
                        <div className="value">
                            <span className="text-gradient-red-orange">{this.state.avg3 && this.state.avg3.avg3 && this.state.avg3.avg3.toFixed(1)}</span>
                            <span className="value-total">/5</span>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-3">
                    <div className="card card-average">
                        <div className="title">
                            Notes Ranky
                        </div>
                        <div className="value text-gradient-blue">
                            {this.state.avg3.count}
                        </div>
                    </div>
                </div>
            </div>
        );
          
        const metricsBlock = this.state.metrics && (
            <div className="row metrics">
                <div className="col-md-12 col-lg-12">
                    <div className="card card-average card-metrics">
                        <div className="row">
                            <div className="col-md-3 col-sm-12 google-wrapper" style={{ display: 'flex', flexDirection: 'column'}}>
                                <img src={googleLogo} alt="Google" style={{maxHeight: '3em', margin: '10px'}} />
                                {/* <span style={{color: '#aaaaaa'}}>Mis à jour le {this.state.metrics.created && moment(this.state.metrics.created).format('DD/MM/YYYY')}</span> */}
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="title">
                                    Nouveaux avis
                                </div>
                                <div className="value">
                                    <span
                                        className="metrics-diff"
                                        title={`Avis recoltés depuis l'installation de votre tablette Ranky.`}
                                        data-toggle="tooltip"
                                        data-placement="top"            
                                        >
                                        <span className={(this.state.metrics.last - this.state.metrics.first) > 0 && 'green'}>+{this.state.metrics.last - this.state.metrics.first}</span>
                                    </span>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                                <div className="title">
                                    Variation
                                </div>
                                <div className="value">
                                    <span
                                        className="metrics-diff"
                                        title={`% de variation de votre nombre d'avis depuis l'installation de votre tablette Ranky.`}
                                        data-toggle="tooltip"
                                        data-placement="top"            
                                        >
                                        <span className={(this.state.metrics.last - this.state.metrics.first) > 0 && 'green'}>+{ this.state.metrics.first === this.state.metrics.last ? 0 : (((this.state.metrics.last * 100) / this.state.metrics.first) - 100).toFixed(0)}%</span>
                                    </span>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12">
                            <div className="title">
                                    Total avis
                                </div>
                                <div className="value" style={{color: '#808080'}}>
                                    {this.state.metrics.last}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );

        return(
            <div className="route-wrapper">
                <TopBar
                    title={this.state.place ? `${this.state.place.name} - ${this.state.place.comment}` : ""}
                    subheading="Détails de votre établissement."
                    icon="pe-7s-graph2"
                />
                <div className="app-inner-layout">
                    <div className="app-inner-layout-content">
                        <div className="container-fluid">
                            {
                                this.state.metrics
                                ? metricsBlock
                                : (this.state.metricsError && <ErrorAlert message={this.state.metricsError}/>)
                            }
                            {
                                this.state.avg3
                                ? averageBlock
                                : (this.state.avg3Error ? <ErrorAlert message={this.state.avg3Error}/> : <LoadingSpinner />)
                            }
                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <div className="card-header">
                                            <i className="pe-7s-graph3 header-icon gradient-icon-blue"></i>
                                            Nombres de notes
                                        </div>
                                        <div className="card-body">
                                            {
                                                this.state.ratingsHistory ?
                                                <RatingsHistory
                                                data={[
                                                    {
                                                    key: "Nombre de notes",
                                                    values: this.state.ratingsHistory,
                                                    color: colors.rating1,
                                                    }
                                                ]}
                                                /> :
                                                (this.state.ratingsHistoryError ? <ErrorAlert message={this.state.ratingsHistoryError}/> : <LoadingSpinner />)
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <div className="card-header">
                                            <i className="pe-7s-graph1 header-icon gradient-icon-green-blue"></i>
                                            Moyennes par jour
                                        </div>
                                        <div className="card-body">
                                            {
                                                this.state.averageHistory ?
                                                <AverageHistory
                                                data={this.state.averageHistory}
                                                labels={this.state.labels || []}
                                                stacked={window.innerWidth <= 540}
                                                /> :
                                                (this.state.averageHistoryError ? <ErrorAlert message={this.state.averageHistoryError}/> : <LoadingSpinner />)
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <div className="card-header" style={{ justifyContent: 'space-between'}}>
                                            <div style={{display: 'flex'}}>
                                                <i className="pe-7s-graph1 header-icon gradient-icon-blue"></i>
                                                Notes
                                            </div>
                                            <a href={`${config.apiUrl}/emails/download/${this.props.match.params.hash}?type=token&token=${localStorage.getItem('token')}`} className="btn btn-primary btn-sm">
                                                <i className="pe-7s-download"></i>
                                                Télécharger les données
                                            </a>
                                        </div>
                                            {
                                                this.state.ratings ?
                                                <RatingsTable
                                                data={this.state.ratings}
                                                labels={this.state.labels || []}
                                                /> :
                                                (this.state.ratingsError && <ErrorAlert message={this.state.ratingsError}/>)
                                            }
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                </div>
            </div>
        );
    }
}
export default MetricsEtablissement;



// WEBPACK FOOTER //
// ./src/containers/MetricsEtablissement.js